export default "__VITE_ASSET__Cigk1PHN__"